export default import.meta.ROLLDOWN_FILE_URL_cxxb997tO8ZV8wkN9buWFg